import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27f583f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-container" }
const _hoisted_2 = ["src", "data-instance-id", "data-name", "id"]
const _hoisted_3 = { key: 2 }
const _hoisted_4 = {
  key: 0,
  class: "no-image"
}

import {onMounted, PropType, Ref, ref, useSlots} from "vue";
import FrameOverlay from "@/lib/components/frame/overlay/FrameOverlay.vue";
import {onElementResize} from "@/lib/common/utilities/DomUtilities";
import {SImageData} from "@/lib/store/model/media/SImageData";

// ------------------------------
//  Base
// ------------------------------


export default /*#__PURE__*/_defineComponent({
  name: 'OverlayableImage',
  props: {
  image: Object as PropType<SImageData>,
},
  setup(__props, { expose }) {

const props = __props




const slots = useSlots();

const hasSlot = (name: string) => !!slots[name];

// ------------------------------
//  Overlay's size handlers
// ------------------------------

const HTMLImage: Ref<HTMLVideoElement|undefined> = ref<HTMLVideoElement>();

const overriddenOverlayWidth = ref(),
    overriddenOverlayHeight = ref();

const recalculateOverlayDimensions = () =>
{
  if (HTMLImage.value)
  {
    overriddenOverlayWidth.value = HTMLImage.value.offsetWidth;
    overriddenOverlayHeight.value = HTMLImage.value.offsetHeight;
  }
}

const surveyChangesInImageDimensions = () =>
{
  onElementResize(HTMLImage, recalculateOverlayDimensions);
}

onMounted(() =>
{
  surveyChangesInImageDimensions();

  if (props.image)
    recalculateOverlayDimensions();
});

// ------------------------------
//  Ref exposition
// ------------------------------

expose({
  HTMLImage
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.image)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: __props.image.url,
          alt: "image to annotate",
          "data-instance-id": __props.image.instanceId,
          "data-name": __props.image.name,
          id: 'overlayable-image-'+ __props.image.instanceId,
          class: "overlayable-image",
          ref_key: "HTMLImage",
          ref: HTMLImage
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (__props.image)
      ? (_openBlock(), _createBlock(FrameOverlay, {
          key: 1,
          "overridden-overlay-width": overriddenOverlayWidth.value,
          "overridden-overlay-height": overriddenOverlayHeight.value
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["overridden-overlay-width", "overridden-overlay-height"]))
      : _createCommentVNode("", true),
    (!__props.image)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (!hasSlot('no-image-loaded-message'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "No image loaded"))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "no-image-loaded-message")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})